<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <!-- <a class="navbar-brand" href="#">Inicio</a> -->
      <button type="button" class="navbar-toggler navbar-toggler-right" :class="{ toggled: $sidebar.showSidebar }"
        aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation" @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="nav navbar-nav mr-auto">
          <li class="nav-item">
            <!-- <a class="nav-link" href="#" data-toggle="dropdown">
              <i class="nc-icon nc-palette"></i>
            </a>-->
          </li>
          <!--<base-dropdown tag="li">
            <template slot="title">
              <i class="nc-icon nc-planet"></i>
              <b class="caret"></b>
              <span class="notification">5</span>
            </template>
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </base-dropdown>-->
          <!-- <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="nc-icon nc-zoom-split"></i>
              <span class="d-lg-block">&nbsp;Search</span>
            </a>
          </li>-->
        </ul>
        <ul class="navbar-nav ml-auto">

          <!-- <li class="nav-item">
            <a class="nav-link" href="/admin/user">
              Perfil
            </a>
          </li> -->

          <li class="nav-item">
            <a href="#" class="nav-link" @click="closeSession">
              Cerrar sesión
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  computed: {
    routeName() {
      const { name } = this.$route
      return this.capitalizeFirstLetter(name)
    }
  },
  data() {
    return {
      activeNotifications: false,
      isNightMode: false,

      mode: 1,
      modechange: 1,
    }
  },
  mounted() {
    // this.loadMode();
  },
  methods: {
    ...mapActions(["logout", "getData", "updateData"]),
    // toggleMode() {
    //   console.log("Modo valor al iniciar", this.mode)
    //   Swal.fire({
    //     title: "¡Atención!",
    //     text: "Desea activar el modo nocturno?",
    //     icon: "question",
    //     reverseButtons: true,
    //     showCancelButton: true,
    //     confirmButtonColor: "#651366",
    //     cancelButtonColor: "#F76E2A",
    //     cancelButtonText: "Cancelar",
    //     confirmButtonText: "Si, guardar",
    //   }).then((result) => {
    //     if (result.value) {
    //       this.deleting = true;
    //       let form = {
    //         url: "master/type_config/update",
    //         id: 3,
    //         data: {
    //           value: this.mode == "1" ? "0" : "1",
    //         },
    //       };
    //       console.log("VALOR DE form EN TOGGLE: ", form)
    //       this.updateData(form)
    //         .then((response) => {
    //           if (response.code === 200) {
    //             this.deleting = false;
    //             console.log("form", response)
    //             console.log("VALOR DE MODE Antes ", this.mode)
    //             this.mode = response.data.value;
    //             console.log("VALOR DE MODE despues ", this.mode)
    //             console.log("VALOR DE MODE EN updatedata: ", this.mode)
    //             Swal.fire({
    //               title: "Modo cambiado correctamente",
    //               icon: "success",
    //               showConfirmButton: false,
    //               showLoaderOnConfirm: true,
    //               timer: 1000,
    //             });
    //             window.location.reload();

    //             this.$router.push({ name: this.buttonList });
    //           }
    //         })
    //         .catch((error) => {
    //           console.log(error);
    //           this.deleting = false;
    //           alert("Ocurrió un error, intente más tarde");
    //           this.AllElements();
    //         });
    //     }
    //   });
    // },
    // loadMode() {
    //   let form = {
    //     url: 'master/type_config/3',
    //     params: {
    //     },
    //   };

    //   this.getData(form)
    //     .then((response) => {
    //       if (response.code === 200) {
    //         this.mode = response.data.value;
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },



    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown() {
      this.activeNotifications = false
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false)
    },
    closeSession() {
      console.log('Bye Bye');
      this.logout()
      location.reload();



    }
  }
}

</script>
<style></style>
